var config = {
  'node_env': process.env.NODE_ENV,
  'web': {
    'app': process.env.APP,
    'api': process.env.API,
    'api_doc_gen_01': process.env.API_DOC_GEN,
    'doc': process.env.DOC,
    'login_with_line': process.env.LOGIN_WITH_LINE,
    'omise_public_key': process.env.OMISE_PUBLIC_KEY,
    'omise_vault_api': process.env.OMISE_VAULT_API,
    'omise_core_api': process.env.OMISE_CORE_API,
  },
  'debug': process.env.DEBUG, // console.log, warning, error,
  'token': {
    'secret': process.env.TOKEN_SECRET, // ues for jwt
    'download_pdf_expiresin': process.env.DOWNLOAD_PDF_EXPIRESIN,
  },
}

export default {
  config,
}



// WEBPACK FOOTER //
// ./src/project.js